import { render, staticRenderFns } from "./DefaultersEnrollments.vue?vue&type=template&id=425813af&scoped=true"
import script from "./DefaultersEnrollments.vue?vue&type=script&lang=js"
export * from "./DefaultersEnrollments.vue?vue&type=script&lang=js"
import style0 from "./DefaultersEnrollments.vue?vue&type=style&index=0&id=425813af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425813af",
  null
  
)

export default component.exports